export const CUSTOMER_CARE_PHONE = "888-885-5068";
export const CUSTOMER_CARE_PHONE_HREF = "tel:8888855068";
export const CUSTOMER_CARE_OPTION = "option 2";
export const CUSTOMER_CARE_HOURS = "4:30 am – 6:00 pm PT";

export const CANCELLATION_POLICY = {
  intro:
    "At Cortica, we believe consistent treatment is critical for your child's success. Our cancellation policy ensures fair access to our services and allows us to offer sessions to families waiting for them when cancellations occur.",
  rules: [
    "To ensure that other families can use the canceled sessions, please cancel your appointments with at least three days (72 hours) of notice.",
    "If you contact us to cancel an appointment with less than three days notice, you will be charged a $50 cancellation fee.",
    "You will be charged a $100 cancellation fee if you fail to attend a scheduled appointment.",
    "Two consecutive no-shows may result in removal from the regular schedule.",
    "If you arrive more than ten minutes late for an appointment, your session may be canceled and you will be charged a $50 service fee. Sessions that start late will end at the usually scheduled time.",
  ],
  closing:
    "Unfortunately, these charges cannot be billed to insurance, and we will charge the cancellation fee to the credit card on file for your account. Our team will offer to reschedule your child's sessions as schedules allow.",
  summary:
    "Please cancel at least 72 hours ahead. Late cancellations and missed visits have a fee.",
};

export const contactFormInitValues = {
  firstName: undefined,
  lastName: undefined,
  contactReason: undefined,
  subject: undefined,
  description: undefined,
};

export const contactReasons = [
  {
    value: "Cancel Appointment",
    label: "Cancel Appointment",
  },
  {
    value: "Reschedule Appointment",
    label: "Reschedule Appointment",
  },
  {
    value: "General Scheduling Assistance",
    label: "General Scheduling Assistance",
  },
];
